export const PAGE_SIZE = 50
export const COLUMN_SELECTION_WIDTH = 24
export const THEAD_HEIGHT = 38 // 1 line
export const TAB_HEIGHT = 58

export const ACCEPT_MIME_TYPES = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "video/mp4",
    "application/zip",
    "application/x-zip-compressed",
    "application/zip-compressed"
]

export const COLUMNS = {
    CAMPAIGN_MANAGER: "bookings",
    ARTCHASE: "artchase-bookings"
}
